import React, { useEffect, useState } from 'react';
import { adminApi } from '../../lib/adminApi';
import { Loader2, Euro, ShoppingBag } from 'lucide-react';

const badge = (s) => {
  const map = { paid: 'text-green-400', pending: 'text-yellow-300', initiated: 'text-white/40' };
  const label = { paid: 'Pagato', pending: 'In attesa', initiated: 'Avviato' }[s] || s;
  return <span className={`text-xs ${map[s] || 'text-white/40'}`}>{label}</span>;
};

export default function OrdersPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    adminApi.get('/admin/orders').then((r) => setData(r.data)).catch(() => setData({ items: [], paid_count: 0, revenue: 0 }));
  }, []);

  if (!data) return <div className="text-white/40 py-10 text-center"><Loader2 className="animate-spin inline" /></div>;

  return (
    <div className="space-y-6" data-testid="orders-panel">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-[#0d0d0d] border border-white/10 rounded-xl p-5" data-testid="stat-revenue">
          <div className="flex items-center gap-2 text-white/50 text-xs uppercase tracking-widest"><Euro size={14} /> Incasso (pagati)</div>
          <div className="text-3xl font-black text-white mt-2">€{(data.revenue || 0).toFixed(2)}</div>
        </div>
        <div className="bg-[#0d0d0d] border border-white/10 rounded-xl p-5" data-testid="stat-paid-orders">
          <div className="flex items-center gap-2 text-white/50 text-xs uppercase tracking-widest"><ShoppingBag size={14} /> Ordini pagati</div>
          <div className="text-3xl font-black text-white mt-2">{data.paid_count || 0}</div>
        </div>
      </div>

      <div className="bg-[#0d0d0d] border border-white/10 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="orders-table">
            <thead>
              <tr className="text-left text-white/40 text-xs uppercase tracking-wider border-b border-white/10">
                <th className="px-4 py-3">Data</th>
                <th className="px-4 py-3">Prodotti</th>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Importo</th>
                <th className="px-4 py-3">Stato</th>
              </tr>
            </thead>
            <tbody>
              {data.items.length === 0 ? (
                <tr><td colSpan={5} className="px-4 py-10 text-center text-white/40">Nessun ordine ancora.</td></tr>
              ) : data.items.map((o) => (
                <tr key={o.id} className="border-b border-white/5 text-white/80">
                  <td className="px-4 py-3 text-white/50">{new Date(o.created_at).toLocaleString('it-IT')}</td>
                  <td className="px-4 py-3">{o.items?.map((i) => `${i.qty}× ${i.title}`).join(', ')}</td>
                  <td className="px-4 py-3 text-white/60">{o.customer_email || '—'}</td>
                  <td className="px-4 py-3">€{(o.amount || 0).toFixed(2)}</td>
                  <td className="px-4 py-3">{badge(o.payment_status)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
